var INT64_MAX = 9007199254740991;
var INT64_MIN = -INT64_MAX;
var MaxEventNameLength = 98; // Client Code = 100 limit; Aria Compact SDK = 98 limit.
// Starts with "Office", and then at least two more alphanumeric tokens that start with capital letters
// Tokens are separated by periods.
// This regex has been manually reviewed for catastrophic backtracking.
// eslint-disable-next-line security/detect-unsafe-regex
var EventNameRegex = /^Office(\.[A-Z][a-zA-Z0-9]*){2,}$/;
// Contains alphanumeric or _ or .
// Must be between 1 and 95 characters long (5 characters reserved for 'Data.')
var AlphanumericRegex = /^[a-zA-Z0-9_\.]{1,95}$/;
export function validateTelemetryEvent(telemetryEvent) {
    if (!isEventNameValid(telemetryEvent.eventName)) {
        throw new Error('Invalid eventName');
    }
    var eventContract = telemetryEvent.eventContract;
    if (eventContract) {
        if (eventContract.name && !isNameValid(eventContract.name)) {
            throw new Error('Invalid eventContract');
        }
        validateDataFields(eventContract.dataFields);
    }
    validateDataFields(telemetryEvent.dataFields);
}
function isEventNameValid(eventName) {
    if (!eventName || eventName.length > MaxEventNameLength) {
        return false;
    }
    return EventNameRegex.test(eventName);
}
function isNameValid(name) {
    return AlphanumericRegex.test(name);
}
function validateDataFields(dataFields) {
    if (!dataFields) {
        return;
    }
    dataFields.forEach(function (dataField) {
        if (typeof dataField.name !== 'string' || !isNameValid(dataField.name)) {
            throw new Error('Invalid dataField name');
        }
        if (dataField.dataType === 2 /* DataFieldType.Int64 */) {
            validateInt(dataField.value);
        }
    });
}
export function validateInt(value) {
    if (typeof value !== 'number' || !isFinite(value) || Math.floor(value) !== value || value < INT64_MIN || value > INT64_MAX) {
        throw new Error("Invalid integer ".concat(JSON.stringify(value)));
    }
}
//# sourceMappingURL=TelemetryEventValidator.js.map